import { ExternalOrderInfo } from "@api/throughShipment/externalOrderApi";
import { ApprovalStatus, convertApprovalStatus } from "@constant/ThroughShipment";

import React from "react";
import { Table } from "antd";
import moment from "moment";

import { Row, Title, RowContent, NormalTitle, GrayText, CustomButton } from "../OrderDisplayComponent/style";

const OrderDetail = (props: { externalOrderInfo: ExternalOrderInfo }) => {
  const { externalOrderInfo } = props;
  const formatData = (data?: string) => {
    if (!data) return "-";
    return moment(data).format("YYYY-MM-DD");
  };
  return (
    <>
      <Row>
        <Title>訂單編號</Title>
        <RowContent width={1000}>
          <Title>{externalOrderInfo.orderNumber}</Title>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>倉庫建立時間</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{formatData(externalOrderInfo?.shippingAt)}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>實際出貨時間</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{formatData(externalOrderInfo?.deliveryAt)}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>實際出貨總數量</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo?.totalShippedQty}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>預期出貨時間</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{formatData(externalOrderInfo?.estimatedShippingDate)}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>預期出貨總數量</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo?.totalOrderedQty}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>指定送達日</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{formatData(externalOrderInfo?.specifiedDeliveryDate)}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>運送編號</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo?.trackingNumber}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>運送方式</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo?.shippingMethod}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>訂單成立時間</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{moment(externalOrderInfo?.createdAt).format("YYYY-MM-DD")}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>訂單申請人</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo?.staff?.name}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>訂單狀態</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo?.status}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px" align="flex-start">
        <NormalTitle>審核狀態</NormalTitle>
        <RowContent width={1000} isRow>
          <NormalTitle marginBottom="12px">{externalOrderInfo.approvalStatus}</NormalTitle>
          <Table
            columns={[
              {
                key: "sectionManagerApproval",
                dataIndex: "sectionManagerApproval",
                title: "一階主管",
                width: 150,
                render: (value) => {
                  return value === ApprovalStatus.NOT_REQUIRED ? (
                    <GrayText>{convertApprovalStatus(value)}</GrayText>
                  ) : (
                    convertApprovalStatus(value)
                  );
                },
              },
              {
                key: "managerApproval",
                dataIndex: "managerApproval",
                title: "二階主管",
                width: 150,
                render: (value) => {
                  return value === ApprovalStatus.NOT_REQUIRED ? (
                    <GrayText>{convertApprovalStatus(value)}</GrayText>
                  ) : (
                    convertApprovalStatus(value)
                  );
                },
              },
              {
                key: "financeApproval",
                dataIndex: "financeApproval",
                title: "財務",
                width: 150,
                render: (value) => {
                  return value === ApprovalStatus.NOT_REQUIRED ? (
                    <GrayText>{convertApprovalStatus(value)}</GrayText>
                  ) : (
                    convertApprovalStatus(value)
                  );
                },
              },
              {
                key: "ceoApproval",
                dataIndex: "ceoApproval",
                title: "執行長",
                width: 150,
                render: (value) => {
                  return value === ApprovalStatus.NOT_REQUIRED ? (
                    <GrayText>{convertApprovalStatus(value)}</GrayText>
                  ) : (
                    convertApprovalStatus(value)
                  );
                },
              },
            ]}
            dataSource={[
              {
                managerApproval: externalOrderInfo.managerApproval,
                sectionManagerApproval: externalOrderInfo.sectionManagerApproval,
                financeApproval: externalOrderInfo.financeApproval,
                ceoApproval: externalOrderInfo.ceoApproval,
              },
            ]}
            pagination={false}
            bordered
          />
          {externalOrderInfo.media && (
            <a href={externalOrderInfo.media} onClick={(e) => e.preventDefault()}>
              <CustomButton type="primary">invoice 下載</CustomButton>
            </a>
          )}
        </RowContent>
      </Row>
    </>
  );
};

export default OrderDetail;
